export const getStopsString = (stops: number) =>
  stops === 0 ? "Nonstop" : stops > 1 ? `${stops} stops` : "1 stop";

export const FARE_GRID_TAG_SEPARATOR = ", ";

/**
 * @deprecated Use getEarnTag from the common module instead.
 * This function returns a string with HTML markup which is not safe.
 * The getEarnTag function provides a safer alternative using JSX.
 */
export const getEarnTagText = (earnRate: string | number) =>
  `<span class="font-bold">Earn ${earnRate}X</span> miles on flights`;
